<template>
  <div class="block container">
    <div class="grid-item attention-state">
      <span v-if="attention.status == 'PENDING'">
        <img
          class="icon icon-svg attention-state-item"
          src="@/static/svg/icono_pendiente_v2.svg"
          alt="pendiente"
        />
      </span>
      <span v-if="attention.status == 'COMPLETED'">
        <img
          class="icon icon-svg attention-state-item"
          src="@/static/svg/icono_check_v2.svg"
          alt="completado"
        />
      </span>
      <span v-if="attention.status == 'FAILED'">
        <img
          class="icon icon-svg attention-state-item"
          src="@/static/svg/icono_nocheck_v2.svg"
          alt="fallido"
        />
      </span>
    </div>
    <div class="grid-item" style="width: 91%;">
      <div class="meta-list">
        <div class="meta-item date">
          <span class="meta-value">{{ attention.dueBy | formatStandardDate }}</span>
        </div>

        <div class="meta-name" style="margin-bottom: 3px;">
          <span class="meta-value">
            {{ attention.responsible.name }}
          </span>

          <pill v-if="attentionEvaluation(attention.participationOf)" status="secondary">
            <component :is="attentionEvaluation(attention.participationOf).icon" />
            {{ attentionEvaluation(attention.participationOf).text }}
          </pill>
        </div>

        <div v-if="attention.status !== 'PENDING'">
          <div
            v-if="attention.participationOf && attention.participationOf.comment.comment"
            class="meta-item comment"
          >
            <span class="meta-value">{{ attention.participationOf.comment.comment }}</span>
          </div>
          <div v-else class="comment">
            <span class="meta-value">Sin Comentario</span>
          </div>
        </div>

        <div class="meta-item registerBy">
          <span>
            Registrado: {{ attention.createdAt | formatStandardDate }},
            {{ attention.creator.name }}
          </span>
        </div>

        <div v-if="attention.status !== 'PENDING' && attention.finishedBy">
          <span class="meta-item close-responsible"
            >Responsable: {{ attention.finishedBy.name }}</span
          >
        </div>
        <div v-else>
          <span class="meta-item close-responsible">Sin responsable de cierre</span>
        </div>

        <div class="attentions-buttons">
          <div v-if="!attention.isDone" class="actions">
            <a
              class="button is-primary"
              style="margin: 17px 17px 17px 0; text-decoration: none;"
              href="#"
              @click.prevent="finishAttention(attention.id)"
              >Finalizar</a
            >
          </div>
          <div v-if="this.canDeleteAttention()">
            <a
              class="button is-danger"
              style="margin: 17px 0; text-decoration: none;"
              href="#"
              @click.prevent="deleteAttention(attention.id)"
              >Eliminar</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment"
import Pill from "@/components/_base/Pill.vue"
import IconHappyFace from "@/components/_base/IconHappyFace.vue"
import IconSadFace from "@/components/_base/IconSadFace.vue"
import IconNeutralFace from "@/components/_base/IconNeutralFace.vue"

export default {
  props: {
    attention: {
      type: Object
    },
    creationDate: {
      type: String
    },
    creator: {
      type: String
    },
    user: {
      type: Object
    }
  },

  methods: {
    navigateTo(route) {
      this.$emit("hello", route)
    },
    finishAttention(attentionId) {
      this.$emit("finish-attention", attentionId)
    },
    deleteAttention(attentionId) {
      this.$emit("delete-attention", attentionId)
    },
    canDeleteAttention() {
      var attentionCreator = this.attention.creator
      var isAttentionCreator = attentionCreator && attentionCreator.id == this.user.id
      return isAttentionCreator || this.user.is_staff
    },
    attentionEvaluation(participation) {
      const evaluation = participation.evaluation || ""

      if (!evaluation) {
        return null
      }

      if (evaluation === "YAY") {
        return {
          icon: "IconHappyFace",
          text: "Resultado positivo"
        }
      }

      if (evaluation === "MEH") {
        return {
          icon: "IconNeutralFace",
          text: "Resultado neutro"
        }
      }

      return {
        icon: "IconSadFace",
        text: "Resultado negativo"
      }
    }
  },

  filters: {
    formatStandardDate(date) {
      if (date === null) {
        return "-"
      } else {
        return moment(date)
          .format("DD/MM/YYYY")
          .replace(/[/]/g, ".")
      }
    }
  },

  components: {
    Pill,
    IconHappyFace,
    IconSadFace,
    IconNeutralFace
  }
}
</script>

<style scoped>
.block {
  background: white;
  border-radius: 8px;
}

.container {
  display: flex;
  justify-content: center;
  padding: 10px 24px 0 24px;
}

.attention-state {
  display: flex;
  flex-direction: column;
  justify-items: flex-start;
  align-items: center;
  font-size: 34px;
  width: auto;
  flex-shrink: 0;
  padding: 22px 16px 0 0;
}

.attention-state-item {
  justify-content: center;
}

.attentions-buttons {
  display: flex;
  justify-content: start;
}

.meta-list {
  margin-bottom: 0;
}

.meta-item {
  margin-bottom: 10px;
  color: gray;
}

.meta-value {
  color: black;
}

.meta-list .meta-name {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.meta-list .meta-name .meta-value {
  color: var(--color-neutral-90);
  font-family: Roboto;
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
}

.meta-list .meta-item.date .meta-value {
  color: var(--color-neutral-50);
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.meta-list .meta-item.registerBy,
.meta-list .meta-item.close-responsible {
  color: var(--color-neutral-90);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}

.comment {
  margin-bottom: 15px !important;
}

.close-responsible {
  font-size: 13px;
}

.registerBy {
  font-size: 13px;
  margin-bottom: 0 !important;
}

.date {
  margin-bottom: 10px !important;
}

@media screen and (max-width: 599px) {
  .attention-state {
    padding-right: 8px;
  }

  .attention-state .icon {
    width: 24px;
    height: 24px;
  }
}
</style>
